// extracted by mini-css-extract-plugin
export default {"content":"style_content__jS8Q2","checkbox":"style_checkbox__7UePn"};